"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const papaparse_1 = __importDefault(require("papaparse"));
async function parseCsvFileAsync(file, hasHeader = false) {
    // Parse CSV file using browser APIs
    // https://www.papaparse.com/
    return new Promise((resolve, reject) => {
        papaparse_1.default.parse(file, {
            header: hasHeader,
            worker: typeof process !== "undefined",
            skipEmptyLines: true,
            complete: resolve,
            error: reject,
        });
    });
}
async function parseCsv(file, hasHeader = false) {
    const parsed = await parseCsvFileAsync(file, hasHeader);
    const parsedData = parsed.data;
    // const parsedHeaders = parsed.meta.fields;
    return parsedData;
}
exports.default = parseCsv;
